<template>
  <div
    class="w-full text-left bg-grey-lighter rounded border py-4"
    ref="dropElement"
  >
    <div class="flex items-center z-0 justify-between px-4">
      <button
        type="button"
        ref="browseButton"
        class="text-xs font-semibold text-grey-darkest hover:text-black"
      >
        <i class="fa fa-paperclip text-brand pr-2"></i> Click to attach file(s)
      </button>
      <button
        type="button"
        class="text-xs font-semibold text-grey-darkest hover:text-black"
        @click="toggleSelectVaultFileModal"
      >
        <i class="fa fa-plus text-brand pr-2"></i>
        Select file(s) from vault
      </button>
    </div>

    <div class="border-b my-4"></div>

    <div class="text-xs flex flex-wrap px-4">
      <span
        v-for="file in vaultFiles"
        :key="file.id"
        class="mr-4 flex items-center my-1"
      >
        <button
          type="button"
          class="text-brand text-lg mr-2"
          @click="removeVaultFile(file)"
        >
          <i class="fa fa-times-circle"></i>
        </button>
        {{ file.filename }}
      </span>
      <span
        v-for="file in uploader.files"
        :key="file.id"
        class="mr-4 flex items-center my-1"
      >
        <button
          type="button"
          class="text-brand text-lg mr-2"
          @click="uploader.removeFile(file)"
        >
          <i class="fa fa-times-circle"></i>
        </button>
        {{ file.name }}
      </span>
    </div>

    <p
      v-if="
        uploader.files && uploader.files.length == 0 && vaultFiles.length == 0
      "
      class="px-4 text-xs py-2"
    >
      Drag and drop here to attach file(s)
    </p>

    <teleport to="body">
      <select-vault-file-modal
        ref="selectVaultFileModal"
        @selected-vault-files="selectedVaultFiles"
      ></select-vault-file-modal>
    </teleport>
  </div>
</template>

<script>
import SelectVaultFileModal from "./SelectVaultFileModal.vue";
import Teleport from "vue2-teleport";

export default {
  name: "FileUpload",
  components: {
    SelectVaultFileModal,
    Teleport,
  },
  data() {
    return {
      vaultFiles: [],
      uploader: {},
    };
  },
  mounted() {
    this.initUploader();
  },
  methods: {
    getFiles() {
      return this.uploader.files.map((file) => file.getNative());
    },
    getVaultFiles() {
      return [...this.vaultFiles];
    },
    cleanup() {
      this.vaultFiles = [];

      this.uploader.splice();
    },
    initUploader() {
      this.uploader = new plupload.Uploader({
        browse_button: this.$refs.browseButton,
        drop_element: this.$refs.dropElement,
        multi_selection: true,
      });

      this.uploader.bind("Error", (uploader, error) => {
        console.error(error);
      });

      this.uploader.init();
    },
    removeVaultFile(file) {
      this.vaultFiles = this.vaultFiles.filter((f) => file.id != f.id);
    },
    selectedVaultFiles(payload) {
      payload.forEach((file) => {
        const exists = this.vaultFiles.find((f) => f.id == file.id);
        if (!exists) {
          this.vaultFiles = [file, ...this.vaultFiles];
        }
      });
      this.toggleSelectVaultFileModal(false);
    },
    toggleSelectVaultFileModal(open = true) {
      if (
        this.$refs.selectVaultFileModal &&
        this.$refs.selectVaultFileModal.$refs.selectVaultFileModal
      ) {
        if (open) {
          this.$refs.selectVaultFileModal.$refs.selectVaultFileModal.open();
        } else {
          this.$refs.selectVaultFileModal.$refs.selectVaultFileModal.close();
        }
      }
    },
  },
};
</script>

<style scoped>
button:focus {
  outline: none;
}
</style>